export const sources={};export const img={src:"__VITE_ASSET__V1ZYpwZc9C51fJhgOTS5xQ__",w:640,h:640};export default{sources:sources,img:img};